import { useContext } from 'react';
import AppContext from '../../../AppContext';
import styles from './CurrentYearExpensesRow.module.css';
import HeaderHelmet, { HeaderHelmetProps } from '../../SubSectionHeader/HeaderHelmet';
import DashboardLink from '../../Navigation/Links/DashboardLink';

interface CurrentYearExpensesHeaderProps {
  helmet: HeaderHelmetProps;
}

export default function CurrentYearExpensesHeader({
  helmet
}: CurrentYearExpensesHeaderProps) {
  const { showBenchmark } = useContext(AppContext);

  return (
    <>
      {/* First row: Category groupings */}
      <div className={`${styles.container} ${styles.categoryHeader} ${showBenchmark ? '' : styles.collapse}`}>
        <h5 style={{ paddingLeft: '0.5rem' }}>
          {helmet.label} [<DashboardLink linkText="Expenses Dashboard" relativeUrl="&SUBD=texpense" />]
        </h5>
        <h5 aria-hidden="true"></h5>
        <h5 aria-hidden="true"></h5>
        <h5 aria-hidden={!showBenchmark}></h5>
        <h5 className={styles.categoryTitle} style={{ gridColumn: 'span 3', textAlign: 'center' }}>
          Title & Escrow Operating Expenses
        </h5>
        <h5 className={styles.categoryTitle} style={{ gridColumn: 'span 4', textAlign: 'center', paddingRight: '10rem' }}>
          Other Expenses
        </h5>
      </div>

      {/* Second row: Column headers */}
      <div className={`${styles.container} ${showBenchmark ? '' : styles.collapse}`}>
        <HeaderHelmet label="" />
        <h5 className="column_align_right">
          Direct
        </h5>
        <h5 className="column_align_right">
          Non-Aff <br /> Agency
        </h5>
        <h5 className="column_align_right">
          Aff <br /> Agency
        </h5>
        <h5 className="column_align_right">
          UnAllocated <br /> LAE
        </h5>
        <h5 className="column_align_right">
          Other <br /> Operations
        </h5>
        <h5 className="column_align_right">
          Investment <br /> Expenses
        </h5>
        <h5 className="column_align_right">
          Total
        </h5>
      </div>
    </>
  );
}
